import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
	mode:'history',
	routes: [
		{
			path: '/',
            component: () => import('../components/index'),
            meta: { title: '首页-信查查网安保' }
		},
		{
			path:'/productAdvantages',
			component: () => import('../components/productAdvantages'),
			meta:{
				title: '产品优势'
			}
		},
		{
			path:'/technical',
			component: () => import('../components/technical'),
			meta:{
				title:'技术支持'
			}
		},
		{
			path:"/technical/:enterId",
			component: () => import('../components/technicalContent'),
			meta:{
				title:"技术支持详情"
			}
		},
		{
			path:"/warehouse",
			component: () => import('../components/library'),
			meta:{
				title:"最新漏洞库"
			}
		},
		{
			path:"/warehouse/:pageId",
			component: () => import('../components/libraryContent'),
			meta:{
				title:"漏洞详情"
			}
		},
		{
			path:"/downloadLoophole",
			component: () => import('../components/downloadLoophole.vue'),
			meta:{
				title:"漏洞数据下载"
			}
		},
		{
			path:"/permeate",
			component: () => import('../components/permeate.vue'),
			meta:{
				title:"渗透测试"
			}
		},
		{
			path:"/audit",
			component: () => import('../components/audit.vue'),
			meta:{
				title:"安全代码审计"
			}
		},
		{
			path:"/loophole",
			component: () => import('../components/loophole.vue'),
			meta:{
				title:"漏洞扫描"
			}
		},
		{
			path:"/login",
			component: () => import('../components/login'),
			meta:{
				title:"登录"
			}
		},
		{
			path:"/loopholeOrder",
			component: () => import('../components/loopholeOrder'),
			meta:{
				title:"漏洞扫描订单"
			}
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js